export default __webpack_public_path__ + "static/media/slide.49881568.png";